var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8151 4.56357L5.81414 15.5645C5.43828 15.9404 4.81489 15.9404 4.43902 15.5645C4.06316 15.1886 4.06316 14.5653 4.43902 14.1894L15.44 3.18845C15.8158 2.81259 16.4392 2.81259 16.8151 3.18845C17.1909 3.56432 17.1909 4.18771 16.8151 4.56357Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8151 15.5655C16.4392 15.9413 15.8158 15.9413 15.44 15.5655L4.43902 4.56451C4.06316 4.18865 4.06316 3.56526 4.43902 3.18939C4.81489 2.81353 5.43828 2.81353 5.81414 3.18939L16.8151 14.1903C17.1909 14.5662 17.1909 15.1896 16.8151 15.5655Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.7996b67d41aedc34b6d096aa884e6611.svg";
export { ForwardRef as ReactComponent };